// extracted by mini-css-extract-plugin
export default {"input":"Radio_input__K8YJA","label":"Radio_label__Bgg5Y"};